import '../../utils/index.mjs';
import _sfc_main from './src/card2.mjs';
export { cardProps } from './src/card.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElCard = withInstall(_sfc_main);

export { ElCard, ElCard as default };
//# sourceMappingURL=index.mjs.map
